import CodeIcon from '@mui/icons-material/Code';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { DialogContent, DialogTitle, Box } from '@mui/material';
import { IconButton } from '@mui/material';
import { Tooltip } from '@mui/material';
import { Dialog } from '@mui/material';
import { useState } from 'react';
import ReactJson from 'react-json-view';

export type RawDataButtonProps = {
  entity: any;
  title?: string;
};

export const RawDataButton = ({
  entity,
  title = 'Raw Data',
}: RawDataButtonProps) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(
        JSON.stringify(entity, null, 2),
      );
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  return (
    <>
      <Tooltip title="View raw data">
        <IconButton onClick={() => setOpen(true)}>
          <CodeIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
          sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
        >
          {title}
          <IconButton
            onClick={handleCopy}
            disabled={copied}
            size="small"
          >
            {copied ? <CheckIcon /> : <ContentCopyIcon />}
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{ backgroundColor: '#2d2d2d', p: 2, borderRadius: 1 }}
          >
            <ReactJson
              src={entity}
              theme="monokai"
              displayDataTypes={false}
              enableClipboard={true}
              collapsed={2}
              style={{
                backgroundColor: 'transparent',
                fontFamily: 'monospace',
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};
